export default "__VITE_ASSET__BDnydGAm__"